var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcDigital(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.78 39.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2px;}.cls-1{stroke:#7ab5e5;}.cls-2{stroke:#314e9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.15 14.84 25.21 17.89 25.21 7.62 37.15 7.62 37.15 17.89 44.18 17.89 44.18 0.6 18.19 0.6 18.19 26.59 44.18 26.59"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.6,
    y1: 36.03,
    x2: 20.29,
    y2: 36.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.95,
    y1: 29.07,
    x2: 13.59,
    y2: 29.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.73,
    y: 22.61,
    width: 23.26,
    height: 16.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.36,
    y1: 32.21,
    x2: 29.99,
    y2: 22.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.73,
    y1: 22.6,
    x2: 18.36,
    y2: 32.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcDigital);
export default __webpack_public_path__ + "static/media/ac-digital.dc6fadb8ddee13880147973f5f9758c1.svg";
export { ForwardRef as ReactComponent };